
// NumeroField.js

import React from 'react';

function NumeroField({ value, onChange }) {
  return (
    <div style={{ marginBottom: '0px' }}>
      <input 
        type="text"
        placeholder="Digite o Número do Imóvel"
        style={{ width: '100px', height: '30px' }}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

export default NumeroField;